import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';
import { ReactComponent as ArrowIcon } from '../../../assets/icons/arrow_sort.svg';
import utils from '../../../utils/utils';
import Loader from '../Loader/Loader';
import Checkbox from '../Form/Checkbox/Checkbox';

const Table = ({
  data, header, className = '', onClick = () => {}, getFullRowData, sort, sortBy, onSortBy, loading,
  checkedItems, onCheck, notFoundText = 'No Data Found',
}) => {
  const onSort = (currentSortBy) => {
    const newSortType = { sortBy: currentSortBy, sort: 'asc' };

    if (sortBy === currentSortBy) {
      newSortType.sort = sort === 'desc' ? 'asc' : 'desc';
    }

    onSortBy(newSortType);
  };

  const onCheckItem = (id) => {
    let newCheckedItems = [...checkedItems, id];

    if (id === 'all') {
      const enabledData = data.filter((d) => !d.checkboxDisabled);

      if (enabledData.length === checkedItems.length) {
        newCheckedItems = [];
      } else {
        newCheckedItems = enabledData.map((d) => d.id);
      }
    } else if (checkedItems.includes(id)) {
      newCheckedItems = checkedItems.filter((p) => p !== id);
    }

    onCheck(newCheckedItems);
  };

  const trClass = [classes.tr];
  if (className) trClass.push(className);

  const arrowIcon = [classes.arrow_icon];
  if (sort === 'desc') arrowIcon.push(classes.arrow_icon_desc);

  return (
    data.length
      ? (
        <div className={classes.table_wrapper}>
          { loading && <Loader />}

          <div className={classes.table__border}>
            <table className={classes.table}>

              <thead className={classes.thead}>
                <tr className={classes.tr}>
                  {onCheck && (
                    <th className={classes.th}>
                      <Checkbox
                        checked={checkedItems.length
                          && checkedItems.length === data.filter((c) => !c.checkboxDisabled).length}
                        onChange={() => onCheckItem('all')}
                      />
                    </th>
                  )}

                  {header.map((h) => (
                    <th
                      key={h.name}
                      className={[
                        classes.th,
                        h.isSelectable ? classes.th_selectable : null,
                        h.path === 'actions' ? classes.actions : null,
                      ].join(' ')}
                      onClick={() => h.isSelectable && onSort(h.path)}
                    >
                      <span className={classes.th_title}>
                        {h.name}

                        {h.isSelectable && (
                          <span className={classes.th_arrow}>
                            { h.path === sortBy && <ArrowIcon className={arrowIcon.join(' ')} />}
                          </span>
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={classes.tbody}>
                {data.map((d, i) => (
                  <tr
                    className={trClass.join(' ')}
                    onClick={() => onClick(getFullRowData ? d : (d.id || d.NDC || d.name))}
                    key={`${d.name} ${i}`}
                  >
                    {onCheck && (
                      <td className={classes.td}>
                        <Checkbox
                          checked={checkedItems.includes(d.id)}
                          disabled={d.checkboxDisabled}
                          onChange={() => onCheckItem(d.id)}
                        />
                      </td>
                    )}

                    {header.map((h) => (
                      <td className={`${classes.td} ${h.path === 'actions' ? classes.actions : ''}`} key={h.name}>
                        {h.type === 'currency'
                          ? utils.formattingCurrency(d[h.path])

                          : (h.render?.(d) || (d[h.path] || ' - '))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )

      : (
        <div className={classes.notResult}>
          { loading && <Loader />}

          {notFoundText}
        </div>
      )
  );
};

Table.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  getFullRowData: PropTypes.bool,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortBy: PropTypes.func,
  checkedItems: PropTypes.array,
  onCheck: PropTypes.func,
  notFoundText: PropTypes.string,
};

Table.defaultProps = {
  checkedItems: [],
};

export default Table;
